import { useQuery } from '@tanstack/react-query';
import {
  UserKeys,
  getCustomSchemas,
  getUserQuery,
} from '../../../../api/users-api';
import CustomSchemasForm from './custom-schemas-form';
import { useParams } from 'react-router-dom';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { Messages } from '../../../../utils/message-constants';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';
import SharedButton from '../../../../shared/buttons/shared-button';

export default function CustomSchemasPage() {
  const { userEmail } = useParams() as { userEmail: string };
  const { changeLogRoles, directoryRoles } = useUserSettings();

  const { data: user } = useQuery(getUserQuery(userEmail));

  const {
    isLoading,
    data: fullSchemaData,
    isFetching,
  } = useQuery({
    queryKey: [UserKeys.CustomSchemas, user?.primaryEmail],
    queryFn: () => getCustomSchemas(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('custom attributes'),
    },
  });

  if (isLoading || !user || isFetching) {
    return (
      <>
        <Box sx={{ position: 'relative', height: '100%' }}>
          {/* Top Right Controls with Skeleton Save Button */}
          <Stack
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="center"
            gap={1}
            sx={{ position: 'absolute', top: -60, right: 0 }}
          >
            <SharedIconButton
              variant="refresh"
              tooltipLabel="Refresh"
              disabled
            />
            <SharedButton variant="primary" disabled>
              Save
            </SharedButton>
          </Stack>

          {/* Content Skeleton Fields */}
          <Box sx={{ flex: 1, height: '100%', overflowY: 'auto' }}>
            <Stack
              sx={{
                p: 2,
                justifyContent: 'center',
                maxWidth: 1000,
                mx: 'auto',
              }}
              gap={1}
            >
              <Skeleton variant="rounded" width="100%" height={153} />
              <Skeleton variant="rounded" width="100%" height={249} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Skeleton variant="rounded" width="100%" height={80} />
            </Stack>
          </Box>
        </Box>
      </>
    );
  } else if (fullSchemaData && fullSchemaData.length > 0) {
    return (
      <CustomSchemasForm
        user={user}
        fullSchemaData={fullSchemaData}
        directoryRoles={directoryRoles}
        changeLogRoles={changeLogRoles}
      />
    );
  } else {
    return (
      <Typography>
        You currently have no created custom attributes on this domain.
      </Typography>
    );
  }
}
